<template>
       <div>
         <v-autocomplete
             ref="picker"
             style="overflow: visible"
             v-model="selectedItems"
             :readonly="items.length === 0"
             :loading="loadingLabels"
             :items="items"
             :search-input.sync="search"
             :filled="filled"
             :outlined="outlined"
             small-chips
             chips
             :dense="dense"
             :disabled="readonly"
             color="blue-grey lighten-2"
             :label="items.length === 0 ? 'No hay etiquetas creadas' : text"
             placeholder="No hay etiquetas seleccionadas"
             item-text="description"
             item-value="id"
             multiple
             return-object
             hide-details
         >


           <template slot="no-data">
             <div class="px-2" v-if="items.length === 0">No se han encontrado etiquetas</div>
             <div class="px-2 body-2" v-else>
               Etiqueta no encontrada
               <v-btn v-if="!disableCreation" x-small depressed color="primary" @click="showLabelCreator">Crearla</v-btn>
             </div>
           </template>
           <template v-slot:selection="data">
             <v-chip
                 small
                 :input-value="data.selected"
                 :color="data.item.color"
             >
                <span :style="{color: data.item.textColor}">
                    {{ data.item.description }}
                </span>
               <v-icon small :color="data.item.textColor"   @click.stop="remove(data.item)">close</v-icon>
             </v-chip>
           </template>
           <template v-slot:item="data">
             <template>
               <v-list-item-content>
                 <v-list-item-title v-html="data.item.description"></v-list-item-title>
               </v-list-item-content>
             </template>
           </template>
         </v-autocomplete>
         <label-creator ref="labelCreator" @created="onLabelCreated"/>
       </div>
</template>

<script>
    import {mapActions, mapState} from 'vuex'
    import LabelCreator from "./LabelCreator";
    const tinycolor = require('tinycolor2')

    export default {
        name: "LabelPicker",
        components: {LabelCreator},
        props: {
            dense:{
              type: Boolean,
              default: false
            },
            text:{
              type: String,
              default: 'Seleccionar etiqueta(s)'
            },
            outlined:{
              type: Boolean,
              default: false
            },
            filled:{
              type: Boolean,
              default: false
            },
            readonly:{
                type: Boolean,
                default: false
            },
            type: {
                type: String,
                default: 'client'
            },
            value: {
                type: Array,
                default: () => []
            },
            disableCreation:{
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                selectedItems: [],
                search: ''
            }
        },
        mounted() {
            const vm = this

            if (vm.labels.length === 0) {
                vm.fetchLabels()
            }

            vm.$nextTick(function () {
                vm.setDefaults()
            })

        },
        methods: {
            ...mapActions(['fetchLabels']),
            setDefaults(){
                const vm = this
                vm.selectedItems = vm.value.map(item => {
                    item.id = Number(item.id)
                    return item
                })
            },
            showLabelCreator() {
                const vm = this
                vm.$refs.picker.blur()
                vm.$refs.labelCreator.show(vm.search, vm.type)
            },
            remove(label) {

                const vm = this
                const index = vm.selectedItems.findIndex(item => item.id === label.id)
                if (index !== -1) {
                    vm.selectedItems.splice(index, 1)
                }
            },
            onLabelCreated(label) {
                const vm = this
                vm.selectedItems.push(label)
            }
        },
        computed: {
            ...mapState(['labels', 'loadingLabels']),
            items() {

                const vm = this
                if (vm.type) {
                    return vm.labels.filter(label => label.type === vm.type)
                        .map(label => {
                            label.textColor = tinycolor(label.color).isLight() ? '#000' : '#FFF'
                            label.id = Number(label.id)
                            return label
                        })
                }

                return vm.labels
                    .map(label => {
                        label.textColor = tinycolor(label.color).isLight() ? '#000' : '#FFF'
                        label.id = Number(label.id)
                        return label
                    })

            }
        },
        watch: {
            selectedItems(val) {
                const vm = this
                vm.$emit('change', val)
            },
            value(){
                const vm = this
                vm.setDefaults()
            }
        }

    }
</script>

<style scoped>

>>>.v-select.v-text-field--enclosed:not(.v-text-field--single-line):not(.v-text-field--outlined) .v-select__selections {
  padding-top: 30px;
  padding-bottom: 10px;
}

</style>
